module.exports = __webpack_public_path__ + "img/appointment.260ece51.svg";